// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blockHead__bl5R5 {
  min-height: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.blockTitle__KD_xn {
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.blockContainer__YDHaj {
  padding: 25px;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--table-box-shadow);
}
@media print {
  .blockContainer__YDHaj {
    background-color: transparent;
    box-shadow: none;
    padding: 0;
  }
}

.translateBlock__DhoI8 {
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.translateLang__E2oAz {
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  color: var(--buttons-surface);
  text-transform: uppercase;
}

.descriptionInfo__pFV4Z {
  color: var(--tables-primary-row-text-main);
}
.descriptionInfo__pFV4Z p,
.descriptionInfo__pFV4Z li {
  font-size: 14px;
  line-height: 17px;
  margin: 0;
}
.descriptionInfo__pFV4Z a {
  color: var(--buttons-surface-2);
  background: transparent !important;
}
.descriptionInfo__pFV4Z span {
  font-size: 14px;
  line-height: 17px;
}
.descriptionInfo__pFV4Z img {
  margin-top: 18px;
  max-width: 100%;
  cursor: zoom-in;
}
.descriptionInfo__pFV4Z video {
  width: 100%;
  min-height: 300px;
  display: block;
}

.onboardBlockHide__RYAmx {
  display: block;
}
@media (max-width: 1280px) {
  .onboardBlockHide__RYAmx {
    display: none;
  }
}

.descrImageWrapper__DL4Ex {
  position: relative;
}

.chartImage__KTuOh {
  width: 100%;
}

.skeletonDescriptionInfoWrapper__jYsBU {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.skeletonDescriptionTitle__iQ44W {
  height: 24px;
  width: 30%;
}

.skeletonDescriptionInfo__sI5ke {
  height: 40px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/components/Description/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,qDAAA;EACA,mCAAA;AAzEF;AA2EE;EALF;IAMI,6BAAA;IACA,gBAAA;IACA,UAAA;EAxEF;AACF;;AA2EA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAxEF;;AA2EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,yBAAA;AAxEF;;AA2EA;EACE,0CAAA;AAxEF;AA2EI;;EAEE,eAAA;EACA,iBAAA;EACA,SAAA;AAzEN;AA4EI;EACE,+BAAA;EACA,kCAAA;AA1EN;AA6EI;EACE,eAAA;EACA,iBAAA;AA3EN;AA8EI;EACE,gBAAA;EACA,eAAA;EACA,eAAA;AA5EN;AA+EI;EACE,WAAA;EACA,iBAAA;EACA,cAAA;AA7EN;;AAkFA;EACE,cAAA;AA/EF;AAgFE;EAFF;IAGI,aAAA;EA7EF;AACF;;AAgFA;EACE,kBAAA;AA7EF;;AAgFA;EACE,WAAA;AA7EF;;AAgFA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA7EF;;AAgFA;EACE,YAAA;EACA,UAAA;AA7EF;;AAgFA;EACE,YAAA;AA7EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.blockHead {\n  min-height: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.blockTitle {\n  font-size: 11px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.blockContainer {\n  padding: 25px;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--table-box-shadow);\n\n  @media print {\n    background-color: transparent;\n    box-shadow: none;\n    padding: 0;\n  }\n}\n\n.translateBlock {\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.translateLang {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--buttons-surface);\n  text-transform: uppercase;\n}\n\n.descriptionInfo {\n  color: var(--tables-primary-row-text-main);\n\n  :global {\n    p,\n    li {\n      font-size: 14px;\n      line-height: 17px;\n      margin: 0;\n    }\n\n    a {\n      color: var(--buttons-surface-2);\n      background: transparent !important;\n    }\n\n    span {\n      font-size: 14px;\n      line-height: 17px;\n    }\n\n    img {\n      margin-top: 18px;\n      max-width: 100%;\n      cursor: zoom-in;\n    }\n\n    video {\n      width: 100%;\n      min-height: 300px;\n      display: block;\n    }\n  }\n}\n\n.onboardBlockHide {\n  display: block;\n  @media (max-width: 1280px) {\n    display: none;\n  }\n}\n\n.descrImageWrapper {\n  position: relative;\n}\n\n.chartImage {\n  width: 100%;\n}\n\n.skeletonDescriptionInfoWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.skeletonDescriptionTitle {\n  height: 24px;\n  width: 30%;\n}\n\n.skeletonDescriptionInfo {\n  height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blockHead": `blockHead__bl5R5`,
	"blockTitle": `blockTitle__KD_xn`,
	"blockContainer": `blockContainer__YDHaj`,
	"translateBlock": `translateBlock__DhoI8`,
	"translateLang": `translateLang__E2oAz`,
	"descriptionInfo": `descriptionInfo__pFV4Z`,
	"onboardBlockHide": `onboardBlockHide__RYAmx`,
	"descrImageWrapper": `descrImageWrapper__DL4Ex`,
	"chartImage": `chartImage__KTuOh`,
	"skeletonDescriptionInfoWrapper": `skeletonDescriptionInfoWrapper__jYsBU`,
	"skeletonDescriptionTitle": `skeletonDescriptionTitle__iQ44W`,
	"skeletonDescriptionInfo": `skeletonDescriptionInfo__sI5ke`
};
module.exports = ___CSS_LOADER_EXPORT___;
